export const EMAIL_INFO_OPTIONS = [
  {
    title: "Informations du document",
    key: "Informations du document",
    options: [
      {
        key: "{{type_document}}",
        value: "Devis, Commande, Avoir, Facture, etc.",
      },
      {
        key: "{{date_document}}",
        value: "Date",
      },
      {
        key: "{{name_document}}",
        value: "Nom du document",
      },
      {
        key: "{{document_total_value}}",
        value: "Montant TTC",
      },
      {
        key: "{{document_total_net}}",
        value: "Montant HT",
      },
      {
        key: "{{numero_document}}",
        value: "Compte",
      },
      {
        key: "{{valid_until}}",
        value: "Date Devis",
      },
      {
        key: "{{payment_deadline_date}}",
        value: "Date d'échéance",
      },
      {
        key: "{{budget_url}}",
        value: "URL pour voir et signer le devis",
      },
    ],
  },
  {
    title: "Relances groupées",
    key: "Relances groupées",
    options: [
      {
        key: "[LISTEDOCUMENTS]",
        value: "Début de la liste des documents éligibles",
      },
      {
        key: "[/LISTEDOCUMENTS]",
        value: "Fin de la liste des documents éligibles",
      },
      {
        key: "{{total_ttc}}",
        value: "Solde",
      },
    ],
  },
  {
    title: "Informations du client",
    key: "Informations du client",
    options: [
      {
        key: "{{name_client}}",
        value: "Nom de l'entreprise",
      },
      {
        key: "{{adresse_1_client}}",
        value: "Voie",
      },
      {
        key: "{{adresse_2_client}}",
        value: "Complément d'adresse",
      },
      {
        key: "{{postal_code_client}}",
        value: "Code postal",
      },
      {
        key: "{{city_client}}",
        value: "Ville",
      },
      {
        key: "{{country_client}}",
        value: "Pays",
      },
      {
        key: "{{phone_client}}",
        value: "Phone",
      },
    ],
  },
  {
    title: "Informations de l'entreprise",
    key: "Informations de l'entreprise",
    options: [
      {
        key: "{{name_company}}",
        value: "Nom de l'entreprise",
      },
      {
        key: "{{adresse_1_company}}",
        value: "Voie",
      },
      {
        key: "{{adresse_2_company}}",
        value: "Complément d'adresse",
      },
      {
        key: "{{postal_code_company}}",
        value: "Code postal",
      },
      {
        key: "{{city_company}}",
        value: "Ville",
      },
      {
        key: "{{country_company}}",
        value: "Pays",
      },
      {
        key: "{{phone_company}}",
        value: "Phone",
      },
    ],
  },
];
